import { Divider, MenuItem, Stack, TextField, Typography } from '@mui/material';
import { WizardValues } from './wizardTypes';

interface Step6Props {
  values: WizardValues;
  setField: <K extends keyof WizardValues>(field: K, value: WizardValues[K]) => void;
}

export const Step6ParentsGuardian = ({ values, setField }: Step6Props) => (
  <Stack spacing={2}>
    <Typography variant="subtitle2">Father</Typography>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField label="Name" fullWidth value={values.fatherName} onChange={(e) => setField('fatherName', e.target.value)} />
      <TextField label="Occupation" fullWidth value={values.fatherOccupation} onChange={(e) => setField('fatherOccupation', e.target.value)} />
    </Stack>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField label="Employer" fullWidth value={values.fatherOrganization} onChange={(e) => setField('fatherOrganization', e.target.value)} />
      <TextField label="Office phone" fullWidth value={values.fatherOfficePhone} onChange={(e) => setField('fatherOfficePhone', e.target.value)} />
    </Stack>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField label="Email" type="email" fullWidth value={values.fatherEmail} onChange={(e) => setField('fatherEmail', e.target.value)} />
      <TextField label="Mobile" fullWidth value={values.fatherPhone} onChange={(e) => setField('fatherPhone', e.target.value)} />
      <TextField label="WhatsApp" fullWidth value={values.fatherWhatsapp} onChange={(e) => setField('fatherWhatsapp', e.target.value)} />
    </Stack>
    <TextField label="Address" fullWidth value={values.fatherAddress} onChange={(e) => setField('fatherAddress', e.target.value)} />

    <Divider />
    <Typography variant="subtitle2">Mother</Typography>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField label="Name" fullWidth value={values.motherName} onChange={(e) => setField('motherName', e.target.value)} />
      <TextField label="Occupation" fullWidth value={values.motherOccupation} onChange={(e) => setField('motherOccupation', e.target.value)} />
    </Stack>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField label="Employer" fullWidth value={values.motherOrganization} onChange={(e) => setField('motherOrganization', e.target.value)} />
      <TextField label="Office phone" fullWidth value={values.motherOfficePhone} onChange={(e) => setField('motherOfficePhone', e.target.value)} />
    </Stack>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField label="Email" type="email" fullWidth value={values.motherEmail} onChange={(e) => setField('motherEmail', e.target.value)} />
      <TextField label="Mobile" fullWidth value={values.motherPhone} onChange={(e) => setField('motherPhone', e.target.value)} />
      <TextField label="WhatsApp" fullWidth value={values.motherWhatsapp} onChange={(e) => setField('motherWhatsapp', e.target.value)} />
    </Stack>
    <TextField label="Address" fullWidth value={values.motherAddress} onChange={(e) => setField('motherAddress', e.target.value)} />

    <Divider />
    <Typography variant="subtitle2">Guardian (optional)</Typography>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField label="Name" fullWidth value={values.guardianName} onChange={(e) => setField('guardianName', e.target.value)} />
      <TextField
        select
        label="Relationship"
        fullWidth
        value={values.guardianRelationship}
        onChange={(e) => setField('guardianRelationship', e.target.value)}
      >
        <MenuItem value="">
          <em>Not specified</em>
        </MenuItem>
        <MenuItem value="Uncle">Uncle</MenuItem>
        <MenuItem value="Aunt">Aunt</MenuItem>
        <MenuItem value="Sibling">Sibling</MenuItem>
        <MenuItem value="Grandparent">Grandparent</MenuItem>
        <MenuItem value="Other">Other</MenuItem>
      </TextField>
    </Stack>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField label="Email" type="email" fullWidth value={values.guardianEmail} onChange={(e) => setField('guardianEmail', e.target.value)} />
      <TextField label="Mobile" fullWidth value={values.guardianPhone} onChange={(e) => setField('guardianPhone', e.target.value)} />
      <TextField label="WhatsApp" fullWidth value={values.guardianWhatsapp} onChange={(e) => setField('guardianWhatsapp', e.target.value)} />
    </Stack>
    <TextField label="Address" fullWidth value={values.guardianAddress} onChange={(e) => setField('guardianAddress', e.target.value)} />
  </Stack>
);
